import { IWsMatch } from '@/app/core/websocket/models';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { inject, Injectable, signal } from '@angular/core';
import { environment } from '@environments/environment';
import { catchError, of } from 'rxjs';
import { GoogleTagAnalyticsService } from '../../../../../services/google-tag/google-tag-analytics.service';
import { EGoogleTagAnalyticsKeys } from '../../enums';
import { MatchSummary } from '../models';
import { Router } from '@angular/router';

@Injectable({
  providedIn: 'root',
})
export class MatchSummaryService {
  private http = inject(HttpClient);
  private env = environment;
  private headers = new HttpHeaders({
    'Content-Type': 'application/json',
  });
  private googleTagAnalyticsService = inject(GoogleTagAnalyticsService);
  private router = inject(Router);

  isLoadingMatchSummary = signal<boolean>(true);
  isErrorMatchSummary = signal<boolean>(false);
  matchSummary = signal<MatchSummary | null>(null);
  wsMatch = signal<IWsMatch | null>(null);

  getMatchSummary(
    matchId: String,
    callback?: () => void,
    isRefreshing: boolean = false
  ) {
    if (!isRefreshing) this.isLoadingMatchSummary.set(true);
    this.isErrorMatchSummary.set(false);

    this.http
      .get<MatchSummary>(`${this.env.baseUrlWeb}/matches/${matchId}/summary`, {
        headers: this.headers,
      })
      .pipe(
        catchError((err) => {
          this.isLoadingMatchSummary.set(false);
          this.isErrorMatchSummary.set(true);

          if (err.error.Code === 'MATCH_ERROR_001') {
            this.router.navigate(['/404']);
          }

          return of(null);
        })
      )
      .subscribe((data) => {
        if (!data) return;

        this.matchSummary.set(data);
        callback && callback();
        this.isLoadingMatchSummary.set(false);

        // google analytics
        this.googleTagAnalyticsService.event(
          EGoogleTagAnalyticsKeys.VIEW_MATCH,
          {
            ...data,
          }
        );
      });
  }

  setWsMatch(data: IWsMatch) {
    this.wsMatch.set(data);
  }
}
